<template>
  <div v-if="visible">
    <div style="width: fit-content">
      <div class="section">
        <el-form ref="basicForm" style="display: flex;flex-direction: column" :inline="true" label-position="left" label-width="90px">
          <div class="el-form-item-group">
            <el-form-item :label="$t('SeaExport.BusinessNo')">
              <el-input v-model="job.jobNo" no="1" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MblNo4')">
              <el-input v-model="job.masterJobNo" no="2" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerReferenceNumber')" :label-width="isZh ? '' : '130px'">
              <cargo-input v-model="job.customerRefNo" no="3" :disabled="readonly" :auto-uppercase="isUppercase" :trim="true" />
            </el-form-item>
          </div>
          <div>
            <el-checkbox v-model="job.mblOnly" no="4" :disabled="readonly" class="checkbox" @change="isMblOnlyChange()">{{ $t('SeaExport.DirectBusiness') }}</el-checkbox>
            <el-checkbox v-model="job.trans" no="5" :disabled="readonly" class="checkbox">{{ $t('SeaImport.ChangeOrders') }}</el-checkbox>
            <el-checkbox v-model="job.warehousing" no="6" :disabled="readonly" class="checkbox" @change="chkWarehousing_changeHandler">{{ $t('SeaExport.Storage') }}</el-checkbox>
            <el-checkbox v-model="job.parts" no="7" :disabled="readonly" class="checkbox">{{ $t('SeaExport.Devanning') }}</el-checkbox>
            <el-checkbox v-model="job.landTransportation" no="8" :disabled="readonly" class="checkbox">{{ $t('SeaExport.DeliveryToDoor') }}</el-checkbox>
            <el-checkbox v-model="job.customs" no="9" :disabled="readonly" class="checkbox" @change="chkCustoms_changeHandler">{{ $t('SeaExport.CustomsDeclaration') }}</el-checkbox>
            <el-checkbox v-model="job.insure" :disabled="readonly" class="checkbox">{{ $t('SeaExport.InsureInfo') }} </el-checkbox>
            <el-checkbox v-model="job.signMBL" no="10" :disabled="readonly" class="checkbox" @change="isMBLChange">MB/L</el-checkbox>
            <el-checkbox v-model="job.signHBL" no="11" :disabled="readonly || (!readonly && job.mblOnly)" class="checkbox" @change="isHBLChange">HB/L</el-checkbox>
            <el-checkbox v-model="job.booking" no="12" :disabled="readonly" class="checkbox">{{ $t('SeaExport.Booking') }}</el-checkbox>
            <el-checkbox v-model="job.itmService" no="13" :disabled="readonly" class="checkbox">{{ $t('SeaExport.ForeignTrade') }}</el-checkbox>
            <el-checkbox v-model="job.international" no="14" :disabled="readonly" class="checkbox">{{ $t('SeaExport.InternationalTransport') }}</el-checkbox>
            <el-checkbox v-model="job.usCustomsClearance" no="15" :disabled="readonly" class="checkbox">{{ $t('queryJob.UsCustomsClearance') }}</el-checkbox>
            <el-checkbox v-if="!job.lclMasterUuid" v-model="job.importManifest" no="15.5" :disabled="readonly">{{ $t('SeaImport.ImportManifest') }}</el-checkbox>
            <el-button
              v-permission="['button_insurance_toInsure']"
              no="16"
              :disabled="isEdit"
              type="primary"
              style="margin-left: 10px"
              @click="pm.toInsure()"
            >{{ $t('SeaExport.Insure') }}</el-button>
          </div>
        </el-form>
      </div>
      <div style="display: flex;">
        <el-form ref="basicForm" style="display: flex;" label-position="right" :label-width="isZh ? '135px' : '160px'">
          <div class="down-first section form-column" style="width: 349px">
            <el-form-item>
              <span slot="label" class="blue">{{ customerLabel1 }}</span>
              <div style="display: flex;align-items: center">
                <el-tooltip
                  v-show="sopImageA"
                  no="17"
                  :content="$t('SeaExport.SOPReceiver')"
                  placement="right-end"
                >
                  <div>
                    <img
                      :src="sopPic"
                      width="18"
                      height="28"
                      style="padding: 5px 0;cursor: pointer"
                      @click="pm.sopChangeCustomerIdHandler()"
                    >
                  </div>
                </el-tooltip>
                <el-tooltip v-show="creditTip.showWarningImageA" :content="creditTip.warningImageATip" placement="right-end">
                  <i
                    class="el-icon-warning red"
                    style="cursor: pointer"
                  />
                </el-tooltip>
                <cargo-sales-company-select
                  no="18"
                  class="shipper-selector"
                  popper-class="shipper-selector-popper"
                  :method-params="{customer:true,active:true,companyLob:'seaImport'}"
                  :check-credit="true"
                  :default-value="job.customerId||''"
                  :disabled="!customerEnabled"
                  :job="job"
                  style="flex: 1;"
                  @parentCallBack="p=>{pm.customerIdEnterHandler(p);pm.clearPoNo()}"
                />
              </div>
            </el-form-item>
            <el-form-item :label="customerLabel2">
              <el-select
                v-model="job.customerRemarks"
                no="19"
                :disabled="readonly"
                :clearable="true"
                :allow-create="true"
                filterable
                @blur="selectCustomerRemarksBlur"
              >
                <el-option
                  v-for="(item,index) in customerRemarks"
                  :key="index"
                  :label="item.lable"
                  :value="item.lable"
                />
              </el-select>
            </el-form-item>
            <template v-if="isZY">
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.AllowSaleProduct') }}</span>
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_AllowSaleProduct"
                  filterable
                  no="allowSaleProduct"
                  :disabled="readonly"
                  clearable
                  :data-filter-function="p => p.statusEnabled && p.seaImportEnabled"
                  :default-value="this.job.saleProductCode || ''"
                  @parentCallBack="p => {this.job.saleProductCode = p.value}"
                />
              </el-form-item>
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.FullOrInside') }}</span>
                <cargo-advance-select
                  :select-type="selectTypeNames.local_cache_FullOrInside$FULL_OR_INSIDE"
                  no="fullOrInside"
                  :disabled="readonly"
                  clearable
                  :default-value="this.job.fullOrInside || ''"
                  @parentCallBack="p => {this.job.fullOrInside = p.value}"
                />
              </el-form-item>
            </template>
            <el-form-item :label="$t('SeaExport.CustomerProperty')">
              <el-tooltip :content="customerTip" placement="bottom">
                <span
                  v-show="customerLevel.customerName"
                  style="color:#FD9A14"
                >LV{{ customerLevel.level }}</span>
                <span
                  v-show="customerLevel.customerName"
                  style="color:#D3A73B"
                >&nbsp;{{ customerLevel.customerName }}</span>
                <span v-show="contractStatusLabel" class="red">&nbsp;({{ contractStatusLabel }})</span>
                <span v-show="advancePaymentLabel" style="color:brown">&nbsp;({{ advancePaymentLabel }})</span>
                <span v-show="stampPictureView.businessDocuments.length > 0" @click="stampPictureView.visible = true">
                  <img :title="$t('Message.BookingSeal')" :src="stampIcon" height="14" style="text-align: right;">
                </span>
              </el-tooltip>
            </el-form-item>

            <el-form-item :label="$t('SeaExport.ContactPerson')">
              <div style="display: flex;justify-content: space-between">
                <el-select v-model="job.customerContact" no="20" :disabled="readonly" style="flex: 1" filterable :allow-create="true" @change="tfLinkmanHandler">
                  <el-option
                    v-for="(item,index) in contactList"
                    :key="index"
                    :label="item.contactPerson"
                    :value="item.contactPerson"
                  />
                </el-select>
                <el-link v-show="!isShowContactPersonDetail" no="21" @click="showContactsInfoDialog=true">{{ $t('SeaExport.Detail') }}</el-link>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Tel')">
              <el-input v-model="job.contactTelephone" no="22" :disabled="readonly" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Fax')">
              <el-input v-model="job.contactFax" no="23" :disabled="readonly" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SolicitationType')">
              <el-select
                v-model="job.cargoSource"
                no="24"
                :disabled="readonly || isCrossTenantSEToSI"
                :placeholder="$t('SeaExport.PleaseSelect')"
                size="mini"
                @change="val=>{
                  pm.cargoSourceChange(val)
                  OverseaCustomerUtils.designationAgentOrCargoSourceChangeHandler(view)
                }"
              >
                <el-option
                  v-for="(item,index) in CARGO_SOURCES"
                  :key="index"
                  :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>&nbsp;
            </el-form-item> <el-form-item :label="$t('SeaExport.CustomJobType')">
              <cargo-advance-select
                no="25"
                filterable
                :clearable="true"
                :placeholder="$t('SeaExport.PleaseSelect')"
                :disabled="readonly"
                :method-params="{type:job.lob}"
                :select-type="selectTypeNames.basic_data_CutomJobType"
                :static-options="customJobTypeList"
                :default-value="job.customJobType "
                @parentCallBack="p=>{job.customJobType=p.value;onCustomJobTypeChange(p)}"
              />
            </el-form-item>
            <el-form-item v-if="job.customJobType && secondaryCustomJobTypeList.length > 0" :label="$t('CargoMsg.Cargo_Grade')">
              <cargo-advance-select
                ref="secondaryCustomJobType"
                no="secondaryCustomJobType"
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_CutomJobType"
                filterable
                :cache="false"
                :default-value="job.secondaryCustomJobType"
                :tag-name="isZh?'name':'englishName'"
                :static-options="secondaryCustomJobTypeList"
                @parentCallBack="p=>{job.secondaryCustomJobType=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OrderChannels')">
              <el-input v-model="job.salesChannel" no="26" :disabled="true" />
            </el-form-item>
            <!--CARGO-18489 新增“渠道单号”字段,显示渠道单号时隐藏委托关联号-->
            <el-form-item v-if="showChannelNo" :label="$t('SeaExport.ChannelNo')">
              <el-input no="27" :value="job.channelNo" :disabled="true" />
            </el-form-item>
            <el-form-item v-if="visibleDesignationAgent" :label="$t('SeaExport.NominatedAgent')">
              <div style="display: flex;align-items: center">
                <el-tooltip
                  v-show="sopImageC"
                  no="28"
                  :content="$t('SeaExport.SOPReceiver')"
                  placement="right-end"
                >
                  <div>
                    <img
                      :class="job.designationAgent&&readonly?'':'not-click'"
                      :src="sopPic"
                      width="18"
                      height="28"
                      style="padding: 5px 0;cursor: pointer"
                      @click="pm.sopChangeBookingAgentHandler()"
                    >
                  </div>
                </el-tooltip>
                <el-tooltip v-show="creditTip.showWarningImageC" :content="creditTip.warningImageCTip" placement="right-end">
                  <i
                    class="el-icon-warning red"
                    style="cursor: pointer"
                  />
                </el-tooltip>
                <cargo-company-select
                  ref="designationAgent"
                  no="29"
                  :disabled="!controllerEnable.txtDesignationAgent"
                  :method-params="{designationAgent:true,active:false}"
                  :check-credit="true"
                  :job="job"
                  :default-value="job.designationAgent||''"
                  tag-name="englishName"
                  style="width: 100%"
                  @change="p=>{pm.designationAgentChangeHandler(p)}"
                />
              </div>
            </el-form-item>
            <el-form-item v-if="!showChannelNo || isCrossTenantSEToSI" :label="$t('SeaExport.ConsignationRelationNumber')">
              <el-input no="30" :value="job.trustFromJob" :disabled="true" />
            </el-form-item>
            <el-form-item v-if="!showChannelNo || isCrossTenantSEToSI" :label="$t('SeaExport.BusinessCommissionedRelationNumber')">
              <el-input no="relatedJob" :value="job.relatedJob" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortOfLoadingAgent')">
              <div style="display: flex;align-items: center">
                <el-tooltip
                  v-show="sopImageB"
                  no="31"
                  :content="$t('SeaExport.SOPReceiver')"
                  placement="right-end"
                >
                  <div>
                    <img
                      :src="sopPic"
                      width="18"
                      height="28"
                      style="padding: 5px 0;cursor: pointer"
                      @click="pm.sopChangeHandler()"
                    >
                  </div>
                </el-tooltip>
                <el-tooltip v-show="creditTip.showWarningImageB" :content="creditTip.warningImageBTip" placement="right-end">
                  <i
                    class="el-icon-warning red"
                    style="cursor: pointer"
                  />
                </el-tooltip>
                <cargo-company-select
                  no="32"
                  :disabled="readonly || isCrossTenantSEToSI"
                  :method-params="{overseaAgent:true,active:true}"
                  :default-value="job.destinationAgent||''"
                  :check-credit="true"
                  :job="job"
                  tag-name="englishName"
                  style="width: 100%"
                  @change="p=>{pm.txtDestinationAgentChangeHandler(p)}"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ShippingCompany')">
              <cargo-company-select
                no="33"
                :disabled="!controllerEnable.txtCarrierId"
                :method-params="{companyLob:'seaImport',seaCmp:true,active:true}"
                :default-value="job.carrierId||''"
                @change="p=>{job.carrierId=p.value;onCarrierIdChange()}"
              />
            </el-form-item>
            <el-form-item v-if="bookingAgentVisible" :label="$t('SeaExport.BookingAgent')">
              <cargo-company-select
                no="34"
                :disabled="!controllerEnable.txtBookingAgent"
                :method-params="{bookingAgent:true,companyLob:'seaImport',active:true}"
                :default-value="job.bookingAgent||''"
                @change="p=>{job.bookingAgent=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BillExchangeAgent')">
              <cargo-company-select
                no="130"
                :disabled="readonly"
                :method-params="{bookingAgent:true,companyLob:'seaImport',active:true}"
                :default-value="job.exChangeAgent||''"
                @change="p=>{job.exChangeAgent=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Mbl2')">
              <div style="display: flex;">
                <cargo-input v-model="job.mbl" no="35" :disabled="!pm.lclMasterFlag || isCrossTenantSEToSI" :auto-uppercase="isUppercase" @change="mbl_Change" />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Hbl2')">
              <cargo-input v-model="job.hbl" no="36" :disabled="readonly || isCrossTenantSEToSI" :auto-uppercase="isUppercase" @change="updateHBL" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsHblNo')">
              <cargo-input v-model="job.customsHbl" no="37" :disabled="readonly" :auto-uppercase="isUppercase" @change="customsHblChange" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SoNo')">
              <so-no-input v-model="job.jobSoNo" no="38" :disabled="readonly" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Vessel')">
              <cargo-input v-model="job.vessel" no="39" :disabled="!pm.lclMasterFlag || isCrossTenantSEToSI" :auto-uppercase="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Voyage')">
              <div style="display: flex;justify-content: space-between">
                <cargo-input v-model="job.voyageFlight" no="40" :disabled="!pm.lclMasterFlag || isCrossTenantSEToSI" style="flex: 1" :auto-uppercase="true" @focus="loadVoyageFlight" />
                <div style="margin-left:5px;"> <el-checkbox v-model="isTwoVessel" :disabled="readonly">{{ $t('SeaExport.SecondCheck') }}</el-checkbox></div>
              </div>
            </el-form-item>
            <el-form-item v-if="isTwoVessel" :label="$t('SeaExport.SecondVessel')">
              <cargo-input v-model="job.secondVessel" no="41" :disabled="readonly" :auto-uppercase="isUppercase" />
            </el-form-item>
            <el-form-item v-if="isTwoVessel" :label="$t('SeaExport.SecondVoyage')">
              <cargo-input v-model="job.secondVoyage" no="42" :disabled="readonly" :auto-uppercase="isUppercase" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfReceipt')">
              <cargo-input v-model="job.dispatchingPlace" no="43" :disabled="readonly" :auto-uppercase="isUppercase" />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.PortOfLoading') }}</span>
              <cargo-advance-select
                ref="loadingPortCode"
                no="44"
                filterable
                :disabled="readonly || isCrossTenantSEToSI"
                :placeholder="$t('SeaExport.RequiredItem')"
                :select-type="selectTypeNames.basic_data_Seaport"
                :default-value="job.loadingPortCode"
                tag-name="englishName"
                :method-params="{}"
                @parentCallBack="p=>{pm.changeLoadingPortCode(p);pm.checkVesselLine(); }"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.PortOfDischarge') }}</span>
              <cargo-advance-select
                no="45"
                filterable
                :disabled="readonly || isCrossTenantSEToSI"
                :placeholder="$t('SeaExport.RequiredItem')"
                :callback-params="{key:'dischargingPortCode'}"
                :select-type="selectTypeNames.basic_data_Seaport"
                :default-value="job.dischargingPortCode"
                tag-name="englishName"
                :method-params="{}"

                @parentCallBack="p=>{job.dischargingPortCode=p.value;pm.dischargingPortCodeChange(p.value);pm.changeDischargingPort2()}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.PlaceOfDelivery') }}</span>
              <cargo-advance-select
                no="destinationPortCode"
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="job.destinationPortCode"
                :placeholder="$t('SeaExport.RequiredItem')"
                @parentCallBack="p=>{job.destinationPortCode=p.value;pm.destinationPortCodeEasyChange(p);pm.changeDestinationPort()}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.FinalDestination') }}</span>
              <cargo-input v-model="job.destinationPlace" no="46" :disabled="readonly" @change="pm.changeDestinationPort()" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Airline')">
              <el-input
                no="47"
                :value="job.loadingPortCode ? pm.vesselLine : ''"
                :disabled="true"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationDate')">
              <el-date-picker
                v-model="job.customsDate"
                no="48"
                :disabled="readonly"
                clearable
                style="width:100%;"
                type="date"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BookingDate')">
              <el-date-picker
                v-model="job.bookingDate"
                no="49"
                :disabled="readonly"
                type="date"
                style="width:100%;"
                clearable
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.DateOfDeparture2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  v-model="job.etd"
                  no="50"
                  :disabled="!controllerEnable.dfETD||!pm.lclMasterFlag||isCrossTenantSEToSI"
                  :placeholder="$t('SeaExport.RequiredItem')"
                  type="date"
                  style="flex: 1; width: 170px; margin-right: 5px"
                  clearable
                  value-format="yyyy-MM-dd"
                  @input="etdChange"
                />
                <span>{{ job.sailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.DateOfArrival2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  v-model="job.eta"
                  no="51"
                  :disabled="!pm.lclMasterFlag || provisionEtdLocked"
                  :placeholder="$t('SeaExport.RequiredItem')"
                  type="date"
                  style="flex: 1;width: 170px; margin-right: 5px"
                  clearable
                  value-format="yyyy-MM-dd"
                  @input="etaChange"
                />
                <span>{{ job.etaSailingDay|filterWeek }}</span>
              </div>
              <span v-if="provisionEtdLocked" style="color: red; font-size: 12px;">(已计提校准不可修改)</span>
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.ActualDateOfDeparture2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  v-model="job.atd"
                  no="52"
                  :disabled="!pm.lclMasterFlag"
                  style="flex: 1;width: 170px; margin-right: 5px"
                  type="date"
                  value-format="yyyy-MM-dd"
                  @input="atdChange"
                />
                <span>{{ job.atdSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.ActualDateOfArrival2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  v-model="job.ata"
                  no="53"
                  :disabled="!pm.lclMasterFlag"
                  style="flex: 1;width: 170px; margin-right: 5px"
                  type="date"
                  value-format="yyyy-MM-dd"
                  @input="ataChange"
                />
                <span>{{ job.ataSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ArrivalTime2')">
              <el-date-picker
                v-model="job.arrivalTime"
                no="123"
                :disabled="readonly"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsBroker')">
              <cargo-advance-select
                no="54"
                :disabled="readonly || (isEdit && !job.customs) "
                :select-type="selectTypeNames.basic_data_Company"
                :data-filter-function="customsBrokerFilter"
                filterable
                :default-value="job.customsBroker||''"
                :placeholder="job.customs?'':$t('SeaExport.PleaseTickCustomsDeclarationOption')"
                :method-params="{customsBroker:true,companyLob:'seaImport',active:true}"
                @parentCallBack="p=>{customsBrokerChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsDeclarationMethod')">
              <cargo-advance-select
                no="customsMethod"
                :disabled="readonly || (isEdit && !job.customs)"
                :select-type="selectTypeNames.basic_data_CustomsMode"
                :method-params="{serviceType:2}"
                tag-value="serialNum"
                filterable
                :default-value="job.customClaim"
                @parentCallBack="p=>{job.customClaim=p.value}"
              />
            </el-form-item>
            <el-form-item v-if="job.customClaim===1" :label="$t('SeaExport.CustomsDeclarationType')">
              <cargo-advance-select
                no="customsDeclarationType"
                :disabled="readonly || (isEdit && !job.customs)"
                :select-type="selectTypeNames.basic_data_CustomsDeclarationType"
                filterable
                :default-value="job.customsDeclarationType===-1?'':job.customsDeclarationType"
                :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
                @parentCallBack="p=>{job.customsDeclarationType=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeMethod')">
              <cargo-advance-select
                no="55"
                :disabled="readonly"
                :clearable="false"
                :select-type="selectTypeNames.basic_data_TradeTerm"
                filterable
                :default-value="job.tradeTerm"
                @parentCallBack="p=>{job.tradeTerm=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ContractRateProperty')">
              <el-select
                ref="bookingTerm"
                v-model="job.bookingTerm"
                no="56"
                :disabled="readonly || isCrossTenantSEToSI"
                :placeholder="readonly ? '' : $t('SeaExport.PleaseSelect')"
                :clearable="false"
                size="mini"
                @change="pm.editInputVesselModel()"
              >
                <el-option
                  v-for="(item,index) in bookingTerms"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ShippingCompanyContractNo')">
              <el-input v-model="job.scNo" no="57" :disabled="readonly" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FreeDemurrage')">
              <auto-number-input
                v-model="job.freeDemurrage"
                :precision="0"
                :min="0"
                :disabled="readonly"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FreeDetention')">
              <auto-number-input
                v-model="job.freeDetention"
                no="58"
                :precision="0"
                :min="0"
                :disabled="readonly"
              />
            </el-form-item>
            <el-form-item :label="$t('Message.TerminalLocation')">
              <cargo-company-select
                no="terminalCompany"
                :disabled="readonly"
                :method-params="{terminalCompany:true,companyLob:'seaImport',active:true}"
                :default-value="job.terminalCompany||''"
                style="width: 100%"
                @change="p=>{JobUtils.terminalCompanyChangeHandler(job, p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('Message.TerminalAddress')">
              <cargo-rich-textarea
                v-model="job.deliveryAddress"
                no="deliveryAddress"
                :disabled="readonly"
                style="height: 110px;"
                @dblclick.native="showAdvanceTextDialog($t('Message.TerminalAddress'),job.deliveryAddress,val=>{job.deliveryAddress=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_TransportSource')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_TransportSource"
                no="transportSource"
                :default-value="job.transportSource"
                :cache="false"
                :disabled="readonly"
                tag-value="code"
                placeholder=" "
                @parentCallBack="item=>job.transportSource=item.value"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ServiceStatisticalArea')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_StatisticArea"
                no="statisticArea"
                :default-value="job.statisticArea"
                :cache="false"
                :disabled="readonly"
                tag-value="code"
                placeholder=" "
                @parentCallBack="item=>job.statisticArea=item.value"
              />
            </el-form-item>
          </div>
          <div class="down-two section form-column">
            <el-form-item :label="$t('SeaExport.DateOfDelivery')">
              <el-date-picker
                v-model="job.deliverDate"
                no="59"
                style="width: 100%"
                :disabled="readonly"
                type="date"
                value-format="yyyy-MM-dd"
                clearable
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DateOfArrivalTheWarehouse')">
              <el-date-picker
                v-model="job.arriveStorageDate"
                no="60"
                style="width: 100%"
                :disabled="readonly"
                type="date"
                value-format="yyyy-MM-dd"
                clearable
              />
            </el-form-item>
            <el-form-item label="">
              <div style="display: flex;justify-content: flex-end">
                <el-button no="61" type="primary" :disabled="readonly" @click="pm.onExcerption()">{{ $t('SeaExport.CopyFromOtherBill') }}</el-button>
                <el-button no="62" type="primary" :disabled="readonly" @click="pm.onCodeSearch()">{{ $t('SeaExport.CodeSearching') }}</el-button>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Shipper')">
              <div style="display: flex;justify-content: space-between">
                <cargo-input v-model="job.shipperCode" no="63" style="width:80px;margin-right: 5px" :disabled="readonly" :placeholder="readonly ? '' : $t('SeaExport.Code2')" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                <cargo-company-select
                  no="64"
                  :disabled="readonly"
                  :method-params="{shipper:true,active:true}"
                  :default-value="job.shipperId||''"
                  tag-name="englishName"
                  style="flex: 1;margin-bottom: 10px"
                  @change="data => {senderAndReceiverChange('shipper',data, 7)}"
                />
              </div>
              <cargo-input
                v-model="job.shipperLine1"
                no="65"
                :disabled="readonly"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :placeholder="readonly ? '' : $t('SeaExport.BillsOfLadingDoubleClickEject')"
                :use-read-only="true"
                @dblclick.native="showSenderAndReceiverDialog('shipper',7, false, notUppercaseShipperConsigneNotify);focusAdvanceTextInput()"
                @blur="pm.shipperAddrChangeFunc()"
              />
              <char-count inline :form="job" prefix="shipper" :line-count="6" style="float:right" />
              <!--  处理弹框中值变更 不同步问题-->
              <cargo-input v-show="false" v-model="job.shipperLine2" no="shipperLine2" @change="pm.shipperAddrChangeFunc()" />
              <cargo-input v-show="false" v-model="job.shipperLine3" no="shipperLine3" @change="pm.shipperAddrChangeFunc()" />
              <cargo-input v-show="false" v-model="job.shipperLine4" no="shipperLine4" @change="pm.shipperAddrChangeFunc()" />
              <cargo-input v-show="false" v-model="job.shipperLine5" no="shipperLine5" @change="pm.shipperAddrChangeFunc()" />
              <cargo-input v-show="false" v-model="job.shipperLine6" no="shipperLine6" @change="pm.shipperAddrChangeFunc()" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Consignee')">
              <div style="display: flex;justify-content: space-between">
                <cargo-input
                  v-model="job.consigneeCode"
                  no="66"
                  style="width:80px;margin-right: 5px"
                  :disabled="readonly"
                  :placeholder="readonly ? '' : $t('SeaExport.Code2')"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  @change="pm.qConsigneeCode_focusOutHandler()"
                />
                <cargo-company-select
                  no="67"
                  :disabled="readonly"
                  :method-params="{consignee:true,active:true}"
                  :default-value="job.consigneeId||''"
                  tag-name="englishName"
                  style="flex: 1;margin-bottom: 10px"
                  @change="data => {senderAndReceiverChange('consignee',data, 7, true, notUppercaseShipperConsigneNotify)}"
                />
              </div>
              <cargo-input
                v-model="job.consigneeLine1"
                no="68"
                :disabled="readonly"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :placeholder="readonly ? '' : $t('SeaExport.BillsOfLadingDoubleClickEject')"
                :use-read-only="true"
                @dblclick.native="showSenderAndReceiverDialog('consignee',7, false, notUppercaseShipperConsigneNotify);focusAdvanceTextInput()"
                @blur="pm.qConsigneeAddr_focusOutHandler(); pm.consigneeAddrChangeFunc()"
              />
              <char-count inline :form="job" prefix="consignee" :line-count="6" style="float:right" />
              <!--  处理弹框中值变更 不同步问题-->
              <cargo-input v-show="false" v-model="job.consigneeLine2" no="consigneeLine2" @change="pm.consigneeAddrChangeFunc()" />
              <cargo-input v-show="false" v-model="job.consigneeLine3" no="consigneeLine3" @change="pm.consigneeAddrChangeFunc()" />
              <cargo-input v-show="false" v-model="job.consigneeLine4" no="consigneeLine4" @change="pm.consigneeAddrChangeFunc()" />
              <cargo-input v-show="false" v-model="job.consigneeLine5" no="consigneeLine5" @change="pm.consigneeAddrChangeFunc()" />
              <cargo-input v-show="false" v-model="job.consigneeLine6" no="consigneeLine6" @change="pm.consigneeAddrChangeFunc()" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.NotifyParty')">
              <div style="display: flex;justify-content: space-between">
                <cargo-input v-model="job.notifyCode" no="69" style="width:80px;margin-right: 5px" :disabled="readonly" :placeholder="readonly ? '' : $t('SeaExport.Code2')" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                <cargo-company-select
                  no="70"
                  :disabled="readonly"
                  :method-params="{notify:true,active:true}"
                  :default-value="job.notifyId||''"
                  tag-name="englishName"
                  style="flex: 1;margin-bottom: 10px"
                  @change="data => {senderAndReceiverChange('notify',data, 7)}"
                />
              </div>
              <cargo-input
                v-model="job.notifyLine1"
                no="71"
                :disabled="readonly"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :placeholder="readonly ? '' : $t('SeaExport.BillsOfLadingDoubleClickEject')"
                :use-read-only="true"
                @dblclick.native="showSenderAndReceiverDialog('notify',7,false, notUppercaseShipperConsigneNotify);focusAdvanceTextInput()"
                @blur="pm.notifyChangeFunc()"
              />
              <char-count inline :form="job" prefix="notify" :line-count="6" style="float:right" />
              <!--  处理弹框中值变更 不同步问题-->
              <cargo-input v-show="false" v-model="job.notifyLine2" no="notifyLine2" @change="pm.notifyChangeFunc()" />
              <cargo-input v-show="false" v-model="job.notifyLine3" no="notifyLine3" @change="pm.notifyChangeFunc()" />
              <cargo-input v-show="false" v-model="job.notifyLine4" no="notifyLine4" @change="pm.notifyChangeFunc()" />
              <cargo-input v-show="false" v-model="job.notifyLine5" no="notifyLine5" @change="pm.notifyChangeFunc()" />
              <cargo-input v-show="false" v-model="job.notifyLine6" no="notifyLine6" @change="pm.notifyChangeFunc()" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ActualQuantity')">
              <auto-number-input
                v-model="job.quantityActual"
                no="72"
                :precision="0"
                :min="0"
                :disabled="readonly || isCrossTenantSEToSI"
                @change="pm.quantityFocusInHandler()"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Package')">
              <cargo-packing-select
                no="73"
                :disabled="readonly || isCrossTenantSEToSI"
                :default-value="job.packing"
                @change="p=>{job.packing=p.value;pm.chargePacking()}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ActualWeight')">
              <div style="display: flex">
                <auto-number-input
                  v-model="job.weightActual"
                  no="74"
                  :precision="3"
                  :min="0"
                  :disabled="readonly || isCrossTenantSEToSI"
                  @change="weightContractChange"
                />
                <span>KGS</span>
              </div>
            </el-form-item>

            <el-form-item :label="$t('SeaExport.ActualVolume')">
              <div style="display: flex">
                <auto-number-input
                  v-model="job.cubageActual"
                  no="75"
                  :precision="3"
                  :min="0"
                  :disabled="readonly || isCrossTenantSEToSI"
                  @change="cubageContractChange"
                />
                <span>CBM</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ChargedWeightRT')">
              <div style="display: flex">
                <auto-number-input
                  v-model="job.chargeWeight"
                  no="76"
                  :precision="3"
                  :min="0"
                  :disabled="!controllerEnable.txtChargeWeight || isCrossTenantSEToSI"
                  @change="pm.chargeWeightChangeHandler()"
                />
                <span>M/T</span>
              </div>
            </el-form-item>
            <el-form-item
              v-show="job.containerLoadType!=='LCL'"
              label-width="0"
              class="auto-width"
            >
              <booking-sea-eq-data-grid
                v-if="job.containerLoadType!=='BULK' && job.containerLoadType!=='LCL'"
                :value="seaEqList"
                :container-load-type="job.containerLoadType"
                :is-edit="isEdit"
                :job="job"
                @eqQuantityChange="eqQuantityChangeHandler"
              />
              <booking-bulk-data-grid
                v-if="job.containerLoadType==='BULK'"
                :value="cargoBulkDetailList"
                :context="context"
                :show-excel-button="false"
                :job-uuid="job.uuid"
                :is-edit="isEdit"
              />
            </el-form-item>

            <!-- <div v-show="job.containerLoadType!=='LCL'">

                <ag-grid-vue
                  :locale-text-func="_i18nGridLocalText"
                  :grid-options="seaEqGrid.gridOptions"
                  :column-defs="seaEqGrid.columnDefs"
                  :row-data="seaEQ"
                  :enable-col-resize="true"
                  :enable-sorting="true"
                  style="width: 100%;height:200px;"
                  class="ag-theme-balham"
                />
              </div>-->
            <el-form-item :label="$t('SeaExport.EnglishDescriptionOfGoods')" style="margin-top: 10px">
              <cargo-rich-textarea
                v-model="job.cargoEnglishName"
                no="77"
                :show-count="true"
                :disabled="readonly || isCrossTenantSEToSI"
                :text-chars="englishNameMaxChars"
                :warning-count="englishNameWarningCount"
                :auto-uppercase="isUppercaseByConfig"
                style="height: 110px;"
                @change="pm.txtCargoEnglishNameChangeHandler()"
                @dblclick.native="showAdvanceTextDialog($t('queryJob.englishDescriptionOfGoods'),job.cargoEnglishName,val=>{job.cargoEnglishName=val},false,null,isUppercaseByConfig , {
                  warningCount: englishNameWarningCount,
                  maxChar: englishNameMaxChars
                })"
              />

            </el-form-item>
            <el-form-item :label="$t('SeaExport.ChineseDescriptionOfGoods')">
              <cargo-rich-textarea
                v-model="job.cargoChineseName"
                no="78"
                :disabled="readonly"
                :text-chars="maxChars"
                :warning-count="warningCount"
                :auto-half-word="false"
                style="height: 110px;"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),job.cargoChineseName,val=>{job.cargoChineseName=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Marks')">
              <cargo-rich-textarea
                v-model="job.mark"
                no="79"
                :show-count="true"
                :disabled="readonly || isCrossTenantSEToSI"
                :text-chars="markMaxChars"
                :warning-count="markWarningCount"
                :auto-uppercase="isUppercaseByConfig"
                style="height: 110px;"
                @change="onMarkChange"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),job.mark,val=>{job.mark=val},false,null,isUppercaseByConfig , {
                  warningCount: markWarningCount,
                  maxChar: markMaxChars
                })"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeTerms2')">
              <cargo-advance-select
                no="80"
                filterable
                :disabled="readonly || isCrossTenantSEToSI"
                :select-type="selectTypeNames.basic_data_IncoTerm"
                :method-params="{}"
                callback-method-type="value"
                :default-value="job.incoTerm+''"

                :callback-params="{key:'incoTerm'}"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PreCollection')">
              <div style="display: flex;justify-content: space-between">
                <el-input-number
                  no="81"
                  :value="job.depositReceived===0 ? undefined: job.depositReceived"
                  style="flex-grow: 1"
                  :disabled="readonly"
                  :controls="false"
                  :precision="3"
                  @input="val=>{job.depositReceived=val}"
                />
                <span>{{ localCurrency }}</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Remarks')">
              <cargo-rich-textarea
                v-model="job.remarks"
                no="82"
                :disabled="readonly || isCrossTenantSEToSI"
                :text-chars="maxChars"
                :warning-count="warningCount"
                :is-trim="true"
                style="height: 110px;"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),job.remarks,val=>{job.remarks=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CategoryOfGoods')">
              <cargo-advance-select
                no="83"
                :allow-create="false"
                :clearable="true"
                :default-value="job.cargoCode"
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_CargoInformation"
                filterable
                @parentCallBack="p=>{pm.cargoCodeChange(p.value)}"
              />
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="job.cargoName"
                no="84"
                :disabled="!(isEdit && job.cargoCode!=='' && job.cargoCode!=null)"
              />
            </el-form-item>
          </div>
          <div class="down-three section form-column">
            <el-form-item :label="$t('SeaExport.WarehouseNo')">
              <el-input v-model="job.warehouseNo" no="85" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FLCLType')">
              <cargo-advance-select
                filterable
                no="86"
                :clearable="false"
                :disabled="!controllerEnable.qCargoType || isCrossTenantSEToSI"
                :select-type="selectTypeNames.local_cache_ImportConstants$_cargoTypeInputList"
                callback-method-type="value"
                :default-value="job.containerLoadType"
                :tag-name="$store.getters.language==='zh'?'chineseName':'englishName'"
                tag-value="code"
                :callback-params="{key:'containerLoadType'}"
                @parentCallBack="obj=>pm.qCargoType_Change(obj)"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ItemNo')" :class="poNoRed?'poNoClass':''">
              <cargo-input v-if="!openProjectConfig" v-model="job.poNo" no="87" :disabled="readonly" :auto-uppercase="isUppercase" :use-read-only="true" />
              <cargo-project-select
                v-if="openProjectConfig"
                no="88"
                :disabled="readonly"
                :default-value="job.poNo"
                :customer-id="job.customerId"
                :is-linked="isProjectLinkedCustomer"
                @change="
                  p => {
                    job.poNo = p.value
                    job.projectName = p.projectName
                    pm.changeProject()
                  }
                "
              />
            </el-form-item>
            <el-form-item
              v-if="openProjectConfig"
              :label="$t('SeaExport.ProjectName')"
            >
              <el-input v-model="job.projectName" no="89" :disabled="true" />
            </el-form-item>
            <el-form-item
              v-if="openProjectConfig"
              :label="$t('SeaExport.ProjectBatch')"
            >
              <el-input v-model="job.projectBatch" no="90" :disabled="readonly" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MBLTransportationClause')">
              <cargo-advance-select
                ref="freightTermMBL"
                no="91"
                filterable
                :clearable="false"
                :disabled="readonly || isCrossTenantSEToSI"
                :select-type="selectTypeNames.basic_data_ShippingTerm"
                :method-params="{}"
                callback-method-type="value"
                :default-value="job.freightTermMBL+''"

                :callback-params="{key:'freightTermMBL'}"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item v-show="!job.mblOnly" :label="$t('SeaExport.HBLTransportationClause')">
              <cargo-advance-select
                no="92"
                filterable
                :clearable="false"
                :disabled="readonly || isCrossTenantSEToSI"
                :select-type="selectTypeNames.basic_data_ShippingTerm"
                :method-params="{}"
                callback-method-type="value"
                :default-value="job.freightTermHBL+''"
                :callback-params="{key:'freightTermHBL'}"
                @parentCallBack="obj=>pm.freightTermHBLChange(obj)"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MasterBLFreightTerm')">
              <cargo-advance-select
                no="93"
                filterable
                :clearable="false"
                :disabled="!pm.lclMasterFlag || isCrossTenantSEToSI"
                :select-type="selectTypeNames.basic_data_PaymentTerm"
                :method-params="{}"
                callback-method-type="value"
                :default-value="job.paymentTermMBL+''"

                :callback-params="{key:'paymentTermMBL'}"
                @parentCallBack="obj=>pm.paymentTermMBLChange(obj)"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfMblPayment')">
              <el-input v-show="!isShowAcPaymentPlaceBL" v-model="mblDoc.paymentPlaceBL" no="94" :disabled="readonly" @change="pm.fieldChangeHandler()" />
            </el-form-item>
            <el-form-item v-show="!job.mblOnly" :label="$t('SeaExport.HBLFreightClause')">
              <cargo-advance-select
                filterable
                no="95"
                :clearable="false"
                :disabled="readonly || isCrossTenantSEToSI"
                :select-type="selectTypeNames.basic_data_PaymentTerm"
                :method-params="{}"
                callback-method-type="value"
                :default-value="job.paymentTermHBL+''"

                :callback-params="{key:'paymentTermHBL'}"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item v-show="!job.mblOnly" :label="$t('SeaExport.PlaceOfHblPayment')">
              <el-input v-model="hdoc.paymentPlaceBL" no="96" :disabled="readonly" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CargoType')">
              <cargo-advance-select
                filterable
                no="97"
                :clearable="false"
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_CargoType"
                callback-method-type="value"
                :default-value="job.cargoType"

                :callback-params="{key:'cargoType'}"
                @parentCallBack="onCargoTypeChagne"
              />
            </el-form-item>
            <el-form-item v-show="!job.mblOnly" :label="$t('SeaExport.HblCargoReleaseWay')">
              <cargo-advance-select
                no="98"
                :disabled="readonly"
                :clearable="false"
                :select-type="selectTypeNames.local_cache_ImportConstants$_importReleaseTypes"
                callback-method-type="value"
                :default-value="job.releaseTypeHbl"
                :headers="[$t('Tool.Code')]"
                :fields="['code']"
                :tag-name="isZh?'chineseName':'englishName'"
                tag-value="code"

                :callback-params="{key:'releaseTypeHbl'}"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MblCargoReleaseWay')">
              <cargo-advance-select
                no="99"
                :disabled="!pm.lclMasterFlag"
                :clearable="false"
                :select-type="selectTypeNames.local_cache_ImportConstants$_importReleaseTypes"
                callback-method-type="value"
                :default-value="job.releaseTypeMbl"
                :headers="[$t('Tool.Code')]"
                :fields="['code']"
                :tag-name="isZh?'chineseName':'englishName'"
                tag-value="code"
                :callback-params="{key:'releaseTypeMbl'}"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.HarborDistrict')">
              <!-- <cargo-rich-textarea v-model="job.portDistrict" :disabled="readonly" />-->
              <cargo-input v-model="job.portDistrict" no="100" :disabled="readonly" :auto-uppercase="isUppercase" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.VesselCode')">
              <cargo-input v-model="job.vesselUnCode" no="101" :disabled="readonly" :auto-uppercase="isUppercase" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BillExchangeDate')">
              <el-date-picker
                v-model="job.transDate"
                no="102"
                :disabled="readonly"
                type="date"
                value-format="yyyy-MM-dd"
                style="width:100%;"
                clearable
                @change="pm.dfCustDate_focusOutHandler()"
              />
            </el-form-item>
            <el-form-item :label="openWarehouse ? $t('SeaExport.WarehouseSupplier') : $t('SeaExport.Warehouse')">
              <cargo-company-select
                no="103"
                :disabled="readonly || (isEdit && !job.warehousing) "
                :method-params="{warehouse:true,active:true}"
                :default-value="job.warehouseCmp||''"
                :placeholder="job.warehousing?'':$t('SeaExport.PleaseCheckWarehouses')"
                @change="p=>{pm.warehouseCmpChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item v-if="openWarehouse" :label="$t('SeaExport.WareHouseName')">
              <el-select
                v-model="job.warehouseName"
                no="warehouseName"
                :disabled="readonly || (isEdit && !job.warehousing) || !job.warehouseCmp"
                :allow-create="true"
                filterable
                :clearable="true"
                @change="warehouseNameChangeHandler"
              >
                <el-option
                  v-for="(item,index) in warehouseNameList"
                  :key="index"
                  :label="item.warehouseName"
                  :value="item.warehouseName"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.SalesCompany') }}</span>
              <el-input v-model="txtSalesOffice" no="104" :disabled="true" :placeholder="$t('SeaExport.RequiredItem')" />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.Sales') }}</span>
              <div style="display: flex;justify-content: space-between">
                <cargo-user-select
                  ref="sales"
                  no="105"
                  :disabled="!saleEnabled"
                  :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
                  :default-value="job.sales||''"
                  :static-options="salesList"

                  :placeholder="salesPrompt"
                  style="width:116px;"
                  @change="p=>{pm.salesChangeHandler(p)}"
                />&nbsp;
                <el-checkbox v-model="job.provisioned" :disabled="true">{{ $t('SeaExport.Accrued') }}</el-checkbox>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SalesOfGoods')">
              <cargo-user-select
                no="106"
                :disabled="readonly"
                :method-params="{category:'role',shape:'salesOfGoods'}"
                :default-value="job.cargoSalesId||''"
                :static-options="cargoSalesList"
                @change="p=>{job.cargoSalesId=p.value;pm.cargoSalesChargeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SalesDepartment')">
              <cargo-department-new-select
                no="107"
                :disabled="readonly || (isEdit && (job.sales=== 0 || !job.sales))"
                :sales-id="Number(job.sales)"
                :office-id="job.salesOffice"
                :department-id="Number(job.salesDepartment)"
                :enables="true"
                @change="p=>{job.salesDepartment=p.value;pm.departmentChargeHandler()}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationCompany')">
              <cargo-advance-select
                no="108"
                :disabled="readonly || opOfficeDisabled"
                :select-type="selectTypeNames.basic_data_Office"
                filterable
                :default-value="job.opOffice"
                :static-options="cacheOffices || allCacheOffices"
                placeholder=""
                @parentCallBack="opOfficeChangeHandler"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.OperationDepartment') }}</span>
              <cargo-department-select
                ref="department"
                no="109"
                :disabled="!saleEnabled"
                :office-id="Number(job.opOffice)"
                :enables="true"
                :department-id="Number(job.opDepartment)"
                @change="p=>{job.opDepartment=p.value}"
              />
            </el-form-item><el-form-item :label="$t('SeaExport.Operation')">
              <cargo-user-select
                :disabled="readonly"
                no="110"
                :method-params="{officeId:job.opOffice,category:'role',shape:'siop'}"
                :default-value="job.op||''"
                :static-options="userPortRoleData.op"
                @change="p=>{job.op=p.value;pm.opChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerOffice')">
              <cargo-office-select
                no="csrOffice"
                :disabled="true"
                :office-id="Number(job.csrOffice)"
                @change="p=>{job.csrOffice=p.value;job.csrDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('Message.Customer_Service') }}</span>
              <cargo-department-select
                no="csrDepartment"
                :office-id="Number(job.csrOffice)"
                :enables="true"
                :disabled="readonly"
                :department-id="Number(job.csrDepartment)"
                @change="p=>{job.csrDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerService')">
              <cargo-user-select
                ref="csr"
                no="111"
                :disabled="readonly"
                :method-params="{category:'role',shape:'csr'}"
                :default-value="job.csr||''"
                :static-options="userPortRoleData.csr"
                @change="p=>{pm.csrChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DocumentOffice')">
              <cargo-office-select
                no="dcOffice"
                :disabled="true"
                :office-id="Number(job.dcOffice)"
                @change="p=>{job.dcOffice=p.value;job.dcDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('Message.Documentation_Department') }}</span>
              <cargo-department-select
                no="dcDepartment"
                :office-id="Number(job.dcOffice)"
                :enables="true"
                :disabled="readonly"
                :department-id="Number(job.dcDepartment)"
                @change="p=>{job.dcDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Documents')">
              <cargo-user-select
                ref="dc"
                no="112"
                :disabled="readonly"
                :method-params="{category:'role',shape:'doc'}"
                :default-value="job.dc||''"
                :static-options="userPortRoleData.doc"
                @change="p=>{pm.dcChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirlineOffice')">
              <cargo-office-select
                no="plannerOffice"
                :disabled="true"
                :office-id="Number(job.plannerOffice)"
                @change="p=>{job.plannerOffice=p.value;job.plannerDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.AirlineDepartment') }}</span>
              <cargo-department-select
                no="plannerDepartment"
                :office-id="Number(job.plannerOffice)"
                :enables="true"
                :disabled="readonly"
                :department-id="Number(job.plannerDepartment)"
                @change="p=>{job.plannerDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirlinePerson')">
              <cargo-user-select
                no="113"
                :disabled="readonly"
                :method-params="{category:'role',shape:'seaLine'}"
                :default-value="job.planner||''"
                :static-options="userPortRoleData.seaLine"
                @change="p=>{job.planner=p.value;pm.txtPlannerChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PolOperation')">
              <cargo-user-select
                no="114"
                :disabled="readonly"
                :method-params="{category:'role',shape:'siop'}"
                :default-value="job.loadingPortOp||''"
                @change="p=>{job.loadingPortOp=p.value;}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PodOperation')">
              <cargo-user-select
                no="115"
                :disabled="readonly"
                :method-params="{category:'role',shape:'siop'}"
                :default-value="job.destinationPortOp||''"
                @change="p=>{job.destinationPortOp=p.value;}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FieldOperation')">
              <cargo-user-select
                :disabled="readonly"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'siteOp'}"
                :default-value="job.siteOP||''"
                :static-options="userPortRoleData.siteOp"
                @change="p=>{JobUtils.siteOpChangeHandler(job, p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OverseaCustomerService')">
              <cargo-user-select
                ref="overseaOp"
                no="overseaOp"
                :disabled="readonly"
                class="input2"
                :default-value="job.overseaOp||''"
                :method-params="{category:'role',shape:'overseaOp'}"
                :static-options="isHC ? null : (userPortRoleData.overseaOp || overseaAgentUsersList)"
                :merge-load="true"
                @change="p=>{
                  job.overseaOp = p.value
                  OverseaCustomerUtils.overseaOpChangeHandler(view, p)
                }"
              />
            </el-form-item>
            <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole1')">
              <cargo-user-select
                ref="userDefinedRoleId1"
                no="userDefinedRoleId1"
                :disabled="readonly"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
                :default-value="job.userDefinedRoleId1||''"
                :merge-load="true"
                :static-options="userPortRoleData.userDefinedRole1"
                @change="p=>{pm.userDefinedRoleId1Handler(p)}"
              />
            </el-form-item>
            <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole2')">
              <cargo-user-select
                ref="userDefinedRoleId2"
                no="userDefinedRoleId2"
                :disabled="readonly"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
                :default-value="job.userDefinedRoleId2||''"
                :merge-load="true"
                :static-options="userPortRoleData.userDefinedRole2"
                @change="p=>{pm.userDefinedRoleId2Handler(p)}"
              />
            </el-form-item>
            <div>

              <special-requests-grid
                ref="selectedSpecialRequest"
                v-model="job.satisfiedRequests"
                no="116"
                :customer-id="Number(job.customerId)"
                :lob="job.lob"
                :job="job"
                :is-edit="isEdit"
              />
            </div>
          </div>
          <div class="down-four section form-column">
            <el-form-item :label="$t('SeaExport.UserDefinedField1')">
              <el-input
                v-model="job.userDefinedField1"
                no="117"
                :disabled="readonly"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField1'),job.userDefinedField1,val=>{job.userDefinedField1=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField2')">
              <el-input
                v-model="job.userDefinedField2"
                no="118"
                :disabled="readonly"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField2'),job.userDefinedField2,val=>{job.userDefinedField2=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField3')">
              <el-input
                v-model="job.userDefinedField3"
                no="119"
                :disabled="readonly"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField3'),job.userDefinedField3,val=>{job.userDefinedField3=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField4')">
              <el-input
                v-model="job.userDefinedField4"
                no="120"
                :disabled="readonly"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField4'),job.userDefinedField4,val=>{job.userDefinedField4=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TaxNature')">
              <el-select
                v-model="job.taxNature"
                :disabled="readonly"
                no="taxNature"
                :placeholder="$t('SeaExport.PleaseSelect')"
                size="mini"
              >
                <el-option
                  v-for="(item,index) in TAX_NATURES"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>&nbsp;
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
    <cargo-contacts-info-dialog
      v-if="showContactsInfoDialog"
      :visible.sync="showContactsInfoDialog"
      :customer-id="job.customerId"
      :customer-contact="job.customerContact"
    />
    <sop-dialog
      :visible.sync="sopDialog.visible"
      :cmp-idx="sopDialog.cmpIdx"
      :job="job"
      :agent="sopDialog.agent"
      lob="SI"
      :contact-list="sopDialog.contactList"
      @updateJob="$emit('updateJob')"
    />

    <!-- 高级文本弹框 -->
    <el-dialog
      ref="advanceTextDialog"
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        v-model="advanceTextDialog.value"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :disabled="readonly"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button v-show="!readonly" no="121" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="122"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>

    <!--  单号抄录-->
    <import-prompt-title-dialog
      :visible.sync="importPromptTitleDialog.visible"
      :lob="job.lob"
      @selected="p=>{pm.onExcerptionChangeFunc(p)}"
    />

    <!--  代码检索-->
    <import-bill-address-title-dialog :visible.sync="billAddressDialog.visible" :job="job" @callback="p=>{pm.codeSearchCallback(p)}" />

    <!-- 订舱章弹窗 -->
    <stamp-picture-view
      :visible.sync="stampPictureView.visible"
      :business-documents="stampPictureView.businessDocuments"
    />
  </div>
</template>

<script>
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import sopPic from '@/assets/sop.png'
import bookingBulkDataGrid from '@/components/Cargo/Job/bookingBulkDataGrid'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoContactsInfoDialog from '@/components/Cargo/Job/cargoContactsInfoDialog'
import cargoDepartmentNewSelect from '@/components/Cargo/Common/cargoDepartmentNewSelect'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import cargoProjectSelect from '@/components/Cargo/Common/cargoProjectSelect'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import sopDialog from '@/components/Cargo/Job/sopDialog'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { BasicTabHP } from './basicTabHP'
import selectData from '@/utils/selectData'
import SpecialRequestsGrid from '@/components/Cargo/Job/specialRequestsGrid'
import BookingSeaEqDataGrid from '@/components/Cargo/Job/bookingSeaEqDataGrid'
import soNoInput from '@/components/Cargo/Job/soNoInput'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import {
  CARGO_SOURCES,
  RATE_TYPE,
  SALES_CHANNEL_OCR_RECOGNITION,
  TAX_NATURES
} from '@/class/cargo/model/parameters/SystemConstants'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import ImportPromptTitleDialog from '@/components/Cargo/Job/importPromptTitleDialog'
import ImportBillAddressTitleDialog from '@/components/Cargo/Job/importBillAddressTitleDialog'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import CargoInput from '@/components/Cargo/Common/cargoInput'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { updateTrackingForDocumentType } from '@/api/fileHistory'
import { BOOKING_TERMS_SEA } from '@/class/cargo/model/parameters/BookingTerm'
import SenderAndReceiver from '@/mixin/SenderAndReceiver'
import { getBranchByLevel, getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import stampIcon from '@/assets/stamp.jpg'
import StampPictureView from '@/components/Cargo/Job/stampPictureView'
import { cache, cacheName } from '@/utils/cacheManager'
import follow from '@/assets/follow.png'
import { getLoading } from '@/utils/utilBaseElement'
import { multiply, mergeArray } from '@/utils/commonUtil'
import lang from '@/lang'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { OverseaCustomerUtils } from '@/class/cargo/model/utils/OverseaCustomerUtils'
import { SeaImCargoDoc } from '@/class/model/booking/SeaImCargoDoc'
import CargoSalesCompanySelect from '@/components/Cargo/Common/cargoSalesCompanySelect'
import { checkPoNoIsExist } from '@/api/booking/job'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect.vue'
import BasicTabMixin from '@/mixin/BasicTabMixin'

export default {
  name: 'BasicTab',
  filters: {
    filterWeek(val) {
      switch (val) {
        case 'TUE':
          return lang.t('SeaExport.TUE')
        case 'WED':
          return lang.t('SeaExport.WED')
        case 'THU':
          return lang.t('SeaExport.THU')
        case 'FRI':
          return lang.t('SeaExport.FRI')
        case 'SAT':
          return lang.t('SeaExport.SAT')
        case 'SUN':
          return lang.t('Pricing.Sun')
        case 'MON':
        default:
          return lang.t('SeaExport.MON')
      }
    }
  },
  components: {
    cargoOfficeSelect,
    StampPictureView,
    CargoInput,
    AutoNumberInput,
    bookingBulkDataGrid,
    ImportBillAddressTitleDialog,
    ImportPromptTitleDialog, BookingSeaEqDataGrid, SpecialRequestsGrid, cargoAdvanceSelect, cargoContactsInfoDialog, sopDialog,
    cargoDepartmentNewSelect, cargoDepartmentSelect, cargoCompanySelect, soNoInput,
    cargoUserSelect, cargoProjectSelect, cargoPackingSelect, cargoRichTextarea, CargoSalesCompanySelect
  },
  mixins: [SenderAndReceiver, BasicTabMixin],
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    viewSource: { // 页面请求发起方
      type: String,
      required: false
    },
    isCrossTenantSEToSI: { // 是否跨租户出口转进口
      type: Boolean,
      required: false
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    },
    bookingAgentVisible: {
      type: Boolean,
      default: true
    },
    processingPromiseList: { // 正在处理中的异步操作对象列表
      type: Array,
      default: () => []
    },
    provisionLock: {
      type: Object,
      default: () => ({ etdLocked: false, feeLocked: false })
    }
  },
  data() {
    return {
      SEUtils,
      isZh: this.$store.getters.language === 'zh',
      img: { follow },
      maxChars: 0,
      warningCount: -1,
      englishNameMaxChars: 0,
      markMaxChars: 0,
      englishNameWarningCount: -1,
      markWarningCount: -1,
      visible: false, // 先隐藏，避免组件在初始化完成前，做一些无效的处理（频繁刷新组件、调用接口等）
      sopPic,
      CARGO_SOURCES,
      TAX_NATURES,
      rateType: RATE_TYPE,
      loading: false,
      pm: new BasicTabHP(this),
      selectTypeNames: TYPE_NAMES,
      bookingTerms: BOOKING_TERMS_SEA,
      allCacheOffices: [], // 缓存的公司列表
      showContactsInfoDialog: false,
      optStatusDefs: {
        edit: 'edit', // edit
        view: 'view' // 查看
      },
      currentOptStatus: 'view',
      sopDialog: {
        visible: false,
        cmpIdx: 0,
        agent: '',
        contactList: []
      },
      billAddressDialog: {
        visible: false
      },
      importPromptTitleDialog: {
        visible: false,
        params: {}
      },
      openProjectConfig: null,
      job: new SeaImportJob().fillDefaultValue().getData(),
      mblDoc: new SeaImCargoDoc().fillDefaultValue().getData(),
      hdoc: new SeaImCargoDoc().fillDefaultValue().getData(),
      jobClass: new SeaImportJob(),
      txtSalesOffice: '', // 销售所在分公司
      contractStatuses: selectData.contractStatuses,
      contractStatusLabel: '',
      customerTip: '',
      customerLevel: {
        level: '',
        customerName: ''
      },
      advancePaymentLabel: '', // 预付款(中邮)
      seaEqList: [],
      cargoBulkDetailList: [],
      isTwoVessel: false, // 是否显示二程航名船次
      partnerManagementMode: 0,
      isHC: false,
      visibleDesignationAgent: true, // 根据揽货类型，显示不同下拉组件
      customerLabel1: '',
      customerLabel2: '',
      configValue: {
        creditOpen: false // 是否开启信控
      },
      creditTip: { // 信控超期提醒
        showWarningImageA: false,
        warningImageATip: '',
        showWarningImageB: false,
        warningImageBTip: '',
        showWarningImageC: false,
        warningImageCTip: ''
      },
      sopConfigOpen: false,
      sopImageA: false,
      sopImageB: false,
      sopImageC: false,
      salesList: null,
      salesPrompt: '',
      contactList: [],
      controllerEnable: {
        qCargoType: false,
        dfETD: false,
        txtCustomerId: false,
        txtDesignationAgent: false,
        txtBookingAgent: false,
        txtCarrierId: false,
        txtChargeWeight: false
      },
      customerRemarks: [], // 实际通知人下拉框数据源
      branchOfficeCheck: false,
      salesOfficeCheck: false, // 是否按照分公司控制 (1:开启分公司过滤 0:关闭分公司过滤)
      isShowAcPaymentPlaceBL: false, // 是否显示主单付款地点
      isUppercase: true,
      syncCustomsHbl: false, // 标识 主单号和海关分单号同步
      stampIcon, // 订舱章
      stampPictureView: {
        businessDocuments: [], // 不为空则显示订舱章
        visible: false
      },
      txtCargoNameEnabled: false, // 货物大类编辑状态
      isAddUserDefinedRoles: false, // 是否显示自定义岗位
      openWarehouse: false,
      warehouseNameList: [],
      loadingPortChanged: false,
      JobUtils,
      overseaAgentUsersList: [], // 海外客服用户列表
      OverseaCustomerUtils,
      view: this,
      poNoRed: false,
      needConfirmProjectNo: false,
      isProjectLinkedCustomer: false,
      userPortRoleData: {
        userDefinedRole1: null,
        userDefinedRole2: null,
        userDefinedRole3: null,
        userDefinedRole4: null,
        overseaOp: null,
        siteOp: null,
        doc: null,
        csr: null,
        op: null,
        seaLine: null,
        airline: null,
        railwayLine: null
      },
      cargoSalesList: null,
      secondaryCustomJobTypeList: [],
      customJobTypeList: [],
      judgmentOfSeaImportVoyageNo: false,
      isZY: false, // 显示中邮选项
      isShowContactPersonDetail: false, // 海创显示详细信息
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      isUppercaseByConfig: true, // CARGO-49117 是否大写
      trustFromEditSales: false // 交叉委托编辑销售
    }
  },
  computed: {
    provisionEtdLocked() {
      return !!(this.provisionLock && this.provisionLock.etdLocked)
    },
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    customerEnabled() {
      // 开启参数1 且是被委托的业务，不可以改委托单位；
      if (this.config && Number(this.config.get('isNewDelegation')) === 1 && this.job.trustFromJob && this.job.relatedJobLob === this.job.lob) {
        return false
      }
      return this.controllerEnable.txtCustomerId && (this.trustFromEditSales || !this.job.relatedJob)
    },
    saleEnabled() {
      return this.isEdit && (this.trustFromEditSales ? true : !this.job.relatedJob) && !this.pm.isWithinCloseAccountDate
    },
    officeList() {
      return this.context.officeList
    },
    config() {
      return this.context.config
    },
    currentOfficeId() {
      return this.$store.getters.currentOfficeId
    },
    showChannelNo() {
      return ['B2B', this.$t('Menu.WallTechFamily')].includes(this.job.salesChannel)
    },
    localCurrency() {
      return RateUtil.localCurrencyByOffice()
    },
    cacheOffices() {
      if (this.isRegionalCommission) {
        return getBranchByLevel(this.job.opOffice)
      } else {
        return null
      }
    },
    // 销售分公司
    salesOffice() {
      return this.job.salesOffice
    }
  },
  watch: {
    currentOfficeId(newVal) {
      // 当前分公司变化时，操作公司变更为当前分公司，操作设为空
      if (this.isEdit) {
        this.job.opOffice = newVal
        this.job.op = ''
      }
    }
  },
  beforeCreate() {
  },
  async created() {
    this.context.loading = true
    const loading = getLoading()
    await this.context.prepareData()
    this.isHC = String(cache.config.get('ToExoSystem')) === 'HC'
    this.configValue.creditOpen = Number(this.config.get('creditOpen')) === 1
    this.partnerManagementMode = Number(this.config.get('PartnerManagementMode')) // 是否启用合作伙伴管理模式
    this.salesOfficeCheck = Number(this.config.get('SalesOfficeCheck')) === 1
    this.isAddUserDefinedRoles = Number(this.config.get('IsAddUserDefinedRoles')) === 1
    this.isProjectLinkedCustomer = Number(this.config.get('isProjectLinkedCustomer')) === 1
    this.judgmentOfSeaImportVoyageNo = Number(this.config.get('JudgmentOfSeaImportVoyageNo')) === 1
    this.isZY = String(this.config.get('ToExoSystem')) === 'zy' // 显示中邮选项
    this.isShowContactPersonDetail = String(this.config.get('ToExoSystem')) === 'HC' // 海创不显示详细信息
    this.notUppercaseShipperConsigneNotify = Number(this.config.get('NotUppercaseShipperConsigneNotify')) !== 1
    this.isUppercaseByConfig = Number(this.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    this.trustFromEditSales = Number(this.config.get('TrustFromEditSales')) === 1
    this.pm.init()

    this.visible = true
    this.context.loading = false
    loading.close()
  },
  beforeMount() {
  },
  methods: {
    setJobSelectValue(obj) {
      this.job[obj.key] = obj.value
    },

    async onShow(row, isRefresh) {
      if (!isRefresh) {
        this.pm.formInitialValue = { ...row }
        return
      }
      this.openProjectConfig = Number(this.config.get('openProjectConfig')) === 1
      this.openWarehouse = Number(this.config.get('isOpenWarehouse')) > 0
      this.needConfirmProjectNo = Number(this.config.get('needConfirmProjectNo')) === 1
      for (const key in this.userPortRoleData) {
        this.userPortRoleData[key] = null
      }
      // 刷新 客户需求表格
      if (this.$refs['selectedSpecialRequest']) {
        this.$refs['selectedSpecialRequest'].toQuery()
      }
      // 取出所有公司 作为操作公司下拉选项
      if (!this.allCacheOffices || this.allCacheOffices.length === 0) {
        this.allCacheOffices = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
      }
      const job = new SeaImportJob(row)
      this.job = row
      // 新增时用户为平台客服，操作不选中平台客服
      if (this.action === 'add' && this.$store.getters.userInfo.chineseName === this.$t('CargoMsg.Cargo_PlatformCustomerService')) {
        if (!this.job.lclMasterUuid) { // 非主票新增小票时执行
          this.job.op = ''
        }
      }

      // 当前为小票赋值主票工作号
      if (this.job.lclMasterUuid && !this.job.masterJobNo) {
        this.job.masterJobNo = this.job.lclMaster ? this.job.lclMaster.jobNo : ''
      }
      // 新建job
      if (!row.uuid) {
        this.seaEqList = job.seaEQ = job.seaEQ || []
        this.cargoBulkDetailList = job.cargoBulkDetail = job.cargoBulkDetail || []
        // 新建时创建 mbl/hbl 避免不打开 mbl/hbl 页签时  未同步数据及创建
        this.hdoc = await job.getMainHbl(true)
        this.mdoc = await job.getMainMbl(true)
        // 进口在新增时赋值
        this.hdoc.signPlaceBL = this.pm.getCity(null)
        this.mdoc.signPlaceBL = this.hdoc.signPlaceBL
        this.job.seaCargoDoc = []
        this.job.seaCargoDoc.push(this.hdoc)
        this.job.seaCargoDoc.push(this.mdoc)
        // CARGO-27090 环海：海运进口复制业务，装箱信息数据没复制下来
        if (this.action === 'copy' && job.seaEQ && job.seaEQ.length > 0 && job.containerLoadType !== 'BULK' && job.containerLoadType !== 'LCL' && (!job.containers || job.containers.length === 0)) {
          await ContainerUtil.autoJustContainerUsages(this.job, this.action)
        }
      } else {
        this.seaEqList = job.seaEQ
        this.cargoBulkDetailList = job.cargoBulkDetail
      }

      // 初始化data值
      this.customerLevel.level = ''
      this.customerLevel.customerName = ''
      this.advancePaymentLabel = ''
      this.contractStatusLabel = ''
      this.customerTip = ''
      this.stampPictureView.businessDocuments = []
      this.loadingPortChanged = false
      await this.pm.changeJob()
      await this.pm.updateView()
      JobUtils.setSailingDay(this.job)
      this.syncCustomsHbl = this.job.mbl === this.job.customsHbl
      OverseaCustomerUtils.loadOverseaAgentChanged(this)
      if (!this.isEdit && this.job.poNo && this.needConfirmProjectNo && !this.openProjectConfig) {
        this.poNoRed = await checkPoNoIsExist(this.job.poNo, this.job.uuid).then(res => res.data) > 0
      }
      JobUtils.loadCompanyCargoSales(this, this.job, this.pm.isSpecifiedSalesBusiness)
      this.setSecondaryCustomJobTypeFunc()
      this.setCustomJobTypeFunc()
      if (this.$store.getters.enableFrontEndPlugin) {
        this.setUserDefinedRoleDataUI()
      }
    },
    warehouseNameChangeHandler(warehouseName) {
      if (this.job.warehouseInfo.length === 0) {
        return
      }
      const warehouseInfo = this.job.warehouseInfo[0]
      warehouseInfo.warehouseName = warehouseName
      const w = this.warehouseNameList.find(item => item.warehouseName === warehouseName)
      if (w) {
        warehouseInfo.warehouseContactTel = w.warehouseContactTel
        warehouseInfo.warehouseContact = w.warehouseContact
        warehouseInfo.warehouseAddress = w.warehouseAddress
        warehouseInfo.mapFile = w.mapFile
        if (w.remarks) {
          warehouseInfo.remarks = w.remarks
        }
      } else {
        warehouseInfo.warehouseContactTel = ''
        warehouseInfo.warehouseContact = ''
        warehouseInfo.warehouseAddress = ''
        warehouseInfo.mapFile = ''
        warehouseInfo.remarks = ''
      }
      this.pm.addWarehouseToModifiedSet(warehouseInfo)
    },
    async getSubmitData() {
      await this.validateForm()

      // await this.pm.updateModel()

      const job = { ...this.job }

      if (job.opDepartment === 0) {
        job.opDepartment = this.$store.getters.currentDeptId
      }
      const submitData = {
        job,
        seaCargoDoc: this.job.seaCargoDoc,
        seaEQ: this.seaEqList,
        delseaEQUuids: this.job.delseaEQUuids,
        cargoBulkDetailList: this.cargoBulkDetailList,
        containers: this.job.containers, // this.job.containers.filter(p => p.isDirty === true), // 实际件毛体 更改影响装箱数据未标记isDirty，后续根据需要再处理
        delContainerUuids: this.job.delContainerUuids, // 删除的箱子uuid
        delContainerUsageUuids: this.job.delContainerUsageUuids // 删除的装箱uuid
      }
      if (this.loadingPortChanged) {
        submitData.usCustomsClearanceList = this.job.usCustomsClearanceList
      }
      return submitData
    },
    async validateForm() {
      await this.pm.checkModel()
    },
    async endTabHandler() {
      await this.pm.updateModel()
    },
    // HBL勾选
    async isHBLChange() {
      if (this.job.signHBL) {
        const job = new SeaImportJob(this.job)
        const hbl = await job.getMainHbl(true)
        await CargoDocUtil.initHBLProperties(hbl, job)
        job.copySCNotifyToDoc(hbl)
      }
    },
    // MBL勾选
    async isMBLChange() {
      if (this.job.signMBL) {
        const job = new SeaImportJob(this.job)
        const hbl = await job.getMainMbl(true)
        await CargoDocUtil.initMBLProperties(hbl, job)
      } else {
        // 取消勾选，mbl页签被隐藏，bookingWorkspace中的this.pendTabSet需要去除mbl页签
        this.$emit('tabNotCheckedCallBack', 'tabMBL')
      }
    },
    // 仓储勾选
    chkWarehousing_changeHandler() {
      if (!this.job.warehousing) {
        this.job.warehouseCmp = 0

        if (this.job.warehouseInfo && this.job.warehouseInfo.length > 0) {
          for (const item of this.job.warehouseInfo) {
            if (item.uuid) {
              item.jobUuid = ''
              this.pm.addWarehouseToModifiedSet(item)
            } else {
              this.pm.removeWarehouseFromModifiedSet(item)
            }
          }
        }
      }
    },
    // 报关勾选
    chkCustoms_changeHandler() {
      if (!this.job.customs) {
        this.job.customsBroker = 0
        this.job.customsDeclarationType = -1
      }
    },
    selectCustomerRemarksBlur(event) {
      this.job.customerRemarks = event.target.value
    },
    /**
     * 海关分单号更新：主单号和海关分单号同步，当海关分单号修改了和主单号就不能同步。
     */
    mbl_Change(value) {
      if (!this.isEdit) return
      if (this.job.containerLoadType === 'FCL') {
        if (this.job.customsHbl === '' || this.syncCustomsHbl) {
          this.job.customsHbl = value
        }
      } else if (this.job.containerLoadType === 'LCL') {
        if (this.job.customsHbl === '' || this.syncCustomsHbl) {
          this.job.customsHbl = value
          //  此步不会用到， this.job.lclMasterUuid 状态下 mbl 被控制的是不允许编辑
          /* if (this.job.lclMasterUuid && this.job.lclMaster.lclSlaves && value !== '') {
            this.job.customsHbl = value + '*' + this.job.lclMaster.lclSlaves.length
          } else {
            this.job.customsHbl = value
          }*/
        }
      }
      this.syncCustomsHbl = this.job.mbl === this.job.customsHbl
    },
    updateHBL(event) {
      if (this.job && this.job.hbl) {
        const cargoDocs = this.job.cargoDoc
        if (cargoDocs !== null && cargoDocs.length > 0) {
          for (const hCargoDoc of cargoDocs) {
            if (hCargoDoc.docType === CargoDocConsts.HBL) {
              hCargoDoc.hblNbr2 = this.job.hbl
            }
          }
        }
      }
    },
    customsHblChange(value) {
      this.syncCustomsHbl = this.job.mbl === this.job.customsHbl
    },
    async etdChange(value) {
      this.job.etd = value
      this.job.sailingDay = JobUtils.dateChange(this.job.etd)
    },
    async etaChange(value) {
      this.job.eta = value
      this.job.etaSailingDay = JobUtils.dateChange(this.job.eta)
      await ChargeUtils.updateETDFee(this.job, this.job.eta, this.context, true)
    },
    async atdChange(value) {
      this.job.atd = value
      this.job.atdSailingDay = JobUtils.dateChange(this.job.atd)
    },
    async ataChange(value) {
      this.job.ata = value
      this.job.ataSailingDay = JobUtils.dateChange(this.job.ata)
    },
    async weightContractChange() {
      this.job.weightContract = this.job.weightActual
      await this.refreshWeightCharge(this.job, this.job.weightContract)
      this.pm.weightFocusInHandler()
    },
    async refreshWeightCharge(job, weight) {
      const charges = ChargeUtils.weightChargesCanUpdate(job)
      if (charges.length > 0) {
        await this.$confirm(this.$t('Message.WeightChangeToRefreshCostBasedOnWeightPrice'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          for (const charge of charges) {
            charge.quantity = weight
            if (charge.unitPriceIncludeTax) {
              ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            } else {
              ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            }
          }
          this.context.modifiedData.charges = this.context.modifiedData.charges || []
          mergeArray(this.context.modifiedData.charges, charges)
          this.context.reloadCharge = true
        }).catch(() => {})
      }
      ChargeUtils.wgttWeightChargesCanUpdate(job, weight, this.context)
    },
    async cubageContractChange() {
      this.job.cubageContract = this.job.cubageActual
      await this.refreshCubageCharge(this.job, this.job.cubageContract)
      this.pm.cubageFocusInHandler(true)
    },
    async refreshCubageCharge(job, cubage) {
      const charges = await ChargeUtils.cubageChargesCanUpdate(job)
      if (charges.length > 0) {
        await this.$confirm(this.$t('Message.CubageChangeToRefreshCostBasedOnCubagePrice'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          for (const charge of charges) {
            charge.quantity = cubage
            if (charge.unitPriceIncludeTax) {
              ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            } else {
              ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            }
          }
          this.context.modifiedData.charges = this.context.modifiedData.charges || []
          mergeArray(this.context.modifiedData.charges, charges)
          this.context.reloadCharge = true
        }).catch(() => {})
      }
    },
    customsBrokerFilter(item, inputVal) {
      if (item.cmpIdx === inputVal) {
        return true
      }
      return item.customsBroker && item.seaImport && item.active
    },
    focusAdvanceTextInput() {
      setTimeout(() => {
        const qlEditor = this.$refs.advanceTextDialog.$el.getElementsByClassName('ql-editor')[0]
        qlEditor.focus()
      }, 100)
    },
    // 组装打印参数
    getPrintData() {
      const params = {}
      params.category = 'SIJOBNO'
      params.ctx = new SeaImportJob(this.job)
      params.JOB_UUID = this.job.uuid
      params.jobuuid = this.job.uuid
      this.$logger.log('params', params)
      return params
      // TemplateSelectorWin.getInstance().showThisWin(_job, "SIJOBNO", params, this);
    },
    // 打印回调
    printedCallback(event) {
      this.$logger.log(event)
      const template = event.template
      const documentType = event.documentType
      if (template && documentType) {
        const objParams = { jobUuid: this.form.uuid, docKeys: documentType.uuid }
        this.$logger.log(objParams)
        updateTrackingForDocumentType(objParams)
      }
    },
    tfLinkmanHandler() {
      const contact = this.contactList.find(item => item.contactPerson === this.job.customerContact)
      if (contact != null) {
        this.job.contactTelephone = contact.telephone
        this.job.contactFax = contact.fax
      }
    },
    opOfficeChangeHandler(param) {
      // 解决切换操作公司时，部门关联选择问题
      this.job.opOffice = param.value
      this.job.opDepartment = null
      // 操作公司变化时，置空操作
      this.job.op = ''
      JobUtils.opOfficeChange({ view: this, job: this.job, warehouseCallback: warehouseId => this.pm.warehouseCmpChangeHandler({ value: warehouseId }) })
      this.contractRuleFieldChange(this.job.customerId, this.job.designationAgent)
    },
    // 直单
    isMblOnlyChange() {
      this.job.signHBL = this.job.mblOnly ? false : this.job.signHBL
    },
    eqQuantityChangeHandler() {
      ChargeUtils.eqQuantityChangeHandler(this.job, this.context)
    },
    async onMarkChange() {
      if (!this.isEdit) return
      await SeaImCargoDoc.changeSynData(new SeaImportJob(this.job), true)
      const mdoc = await new SeaImportJob(this.job).getMainMbl()
      if (mdoc) {
        mdoc._markTime = new Date()
      }
    },
    /**
     * 报关行
     */
    customsBrokerChangeHandler(data) {
      const job = this.job
      // 这个验证必须在 job.customsBroker = data.value 赋值之前，否则此验证无意义
      SEUtils.refreshChargeAccountId(job, 'customsBroker', this.view.$t('SeaExport.CustomsBroker'), this.view.context.modifiedData) // 这里返回true 说明修改了费用结算对象以及开票抬头，需要将费用参与保存
      job.customsBroker = data.value
      this.view.context.reloadCharge = true
    },
    async onCarrierIdChange(scacList, carrierScacEdit) {
      JobUtils.matchUserPortConfig(this, this.job)
      JobUtils.matchRegionWarehouseMappingConfig(this.job)
      // 根据船公司带出对应的scac
      this.job.carrierScac = await JobUtils.getCarrierScac(this.job.carrierId, scacList, carrierScacEdit)
    },
    onCustomJobTypeChange(obj) {
      this.setJobSelectValue(obj)
      JobUtils.matchUserPortConfig(this, this.job)
      JobUtils.matchRegionWarehouseMappingConfig(this.job)
      this.job.secondaryCustomJobType = ''
      this.setSecondaryCustomJobTypeFunc()
      this.contractRuleFieldChange(this.job.customerId, this.job.designationAgent)
    },
    setSecondaryCustomJobTypeFunc() {
      if (this.job.customJobType) {
        this.secondaryCustomJobTypeList = JobUtils.setSecondaryCustomJobTypeList(this.job.customJobType, this.job.lob)
      } else {
        this.secondaryCustomJobTypeList = []
      }
    },
    setCustomJobTypeFunc() {
      this.customJobTypeList = JobUtils.setCustomJobTypeList(this.job.lob, this.job.containerLoadType, this.job.fba)
    },
    // 设置操作分公司
    setOpOffice(val) {
      this.job.opOffice = val
    },
    onCargoTypeChagne(data) {
      this.setJobSelectValue(data)
      JobUtils.matchUserPortConfig(this, this.job)
    },
    // 合同规则相关字段切换时调用刷新【客户、指定货代理】信控信息
    contractRuleFieldChange(customerId, designationAgent) {
      this.pm.checkCredit()
      if (this.configValue.creditOpen) {
        // this.pm.checkCreditByCompany(customerId, 1)
        // this.pm.checkCreditByCompany(designationAgent, 2)
        this.pm.checkNewJobCreditInfo()
      }
    },
    dataFilterCutomJobType(item, inputVal) {
      if (item.code === inputVal || this.job.containerLoadType !== 'BULK') {
        return true
      }
      return item.containerLoadType === 'BULK' || !item.containerLoadType
    },
    loadVoyageFlight() {
      if (this.judgmentOfSeaImportVoyageNo && !this.job.voyageFlight) {
        this.job.voyageFlight = 'V.'
      }
    }
  }
}
</script>

<style scoped lang="scss">
#app .section.form-column {
  width: auto;
}
  .el-form-item-group fieldset{
    min-height: 750px;
    width: 350px;
  }
  .checkbox {
    margin-right: 10px
  }
</style>

<!-- 中文样式 -->
<style scoped lang="scss">
#app.zh {
  .section::v-deep {
    &.down-two {
      width: 400px;
    }
  }
}
</style>

<!-- 英文样式 -->
<style scoped lang="scss">
#app.en {
  .section::v-deep {
    &.down-first {
      min-width: 420px;
    }
    &.down-two {
      width: 442px;
    }
    &.down-three {
      min-width: 364px;
    }
    &.down-four {
      width: 310px;
    }
  }
}
.poNoClass {
  /deep/ .el-input.is-disabled .el-input__inner {
    color: red !important;
  }
}
</style>
